module.exports = __webpack_public_path__ + "static/media/otter.470b21ca.svg";